export default "__VITE_ASSET__CujjLX4G__"